import actionTypes from 'src/modules/redux/actionTypes'

export const setLastChangedField = field => ({
  type: actionTypes.SET_USERS_LIST_LAST_CHANGED_FIELD,
  payload: field
})
